// @flow
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Button from 'material-ui/Button';
import CardMedia from 'material-ui/Card/CardMedia';

import BreadcrumbNav from './BreadcrumbNav';
import SegmentService, {
    EVENTS as SEGMENT_EVENTS
} from '../../lib/segment/SegmentService';
import * as Authorization from '../../lib/authorization';
import * as AppState from '../../state/reducer/app/appState';

import { GYM_TOOLS_CATEGORIES } from './constants';
import Console from '../../lib/debug';
import GridCard from '../common/component/GridCard';

type Props = {
    loggedInUser: object
};

const crumbs = [
    {
        displayString: 'Gym Tools',
        link: `/gymtools`,
        editable: false
    }
];
export class GymToolsViewClass extends PureComponent<Props> {
    launchSegmentEvent = (segmentKey: string) => {
        const { loggedInUser } = this.props;
        SegmentService.track(SEGMENT_EVENTS[segmentKey].key, {
            userId: loggedInUser.id,
            page: 'gymtools'
        });
    };

    getCards = () => {
        const cards = [];
        Object.keys(GYM_TOOLS_CATEGORIES).forEach((categoryKey: string) => {
            const category = GYM_TOOLS_CATEGORIES[categoryKey];
            cards.push(this.getCard(category));
        });
        return <div className="cards">{cards}</div>;
    };

    getCard = (category: object) => {
        const cardActionButton = this.getCardActionButton(category);

        return (
            <GridCard
                category={category}
                cardMedia={
                    <CardMedia className="card-banner empty">&nbsp;</CardMedia>
                }
                cardIconClass={category.iconClass}
                cardActionButtons={cardActionButton}
            />
        );
    };

    getCardActionButton = (category: object) => {
        const authorizationObject = Authorization[category.path];
        const isAuthorized = authorizationObject.isAllowed();

        if (isAuthorized) {
            const url = authorizationObject.path;
            return this.getAuthorizedButton(category, url);
        }

        return this.getUnauthorizedButton(category);
    };

    getAuthorizedButton = (category: {}, url: string) => {
        const onClick = () => {
            this.launchSegmentEvent(category.segmentKey);
        };
        return (
            <Button
                className="button"
                key={category.key}
                href={url}
                onClick={onClick}
            >
                Launch
            </Button>
        );
    };

    getUnauthorizedButton = (category: {}) => {
        const onClick = () => {
            this.launchSegmentEvent(category.segmentKey);
            AppState.showUnauthorizedDialog();
        };

        return (
            <Button className="button" key={category.key} onClick={onClick}>
                Launch
            </Button>
        );
    };

    render() {
        Console.render('GymTools');

        const cards = this.getCards();
        return (
            <div className="cards-view has-filter-bar">
                <div className="jumbotron">
                    <h1>Gym Tools</h1>
                    <p>
                        Manage and engage your athletes while scaling your
                        <br /> impact with TrainHeroic Gym Tools.
                    </p>
                </div>
                <BreadcrumbNav crumbs={crumbs} />
                {cards}
            </div>
        );
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        ...ownProps,
        loggedInUser: state.app.loggedInUser
    };
};

export default connect(mapStateToProps)(GymToolsViewClass);



// WEBPACK FOOTER //
// ./src/view/nav/GymToolsView.jsx